export const makePlural = (value: number): string => {
  return value !== 1 ? "s" : ""
}
